import Journeys from '@/pages/journeys';
import { AccountFeatureFlag, hasFeatureFlag } from '@/services/auth/feature-flags';
import { createFileRoute, redirect } from '@tanstack/react-router';

// `/settings/receipts` redirects to Billing history (SPE-3769). Gated on the same `hydra-billing`
// flag as the rest of billing: flag on, Hydra bounces the URL without booting the embedded app;
// flag off, the embedded Ember app serves it (its own receipts route does the same redirect).
// Only the bare path is owned here — `/settings/receipts/:id` stays embedded (server-rendered
// Stripe receipt), so it is not matched by this exact route.
export const Route = createFileRoute('/_authenticated/settings/receipts')({
  beforeLoad: () => {
    if (hasFeatureFlag(AccountFeatureFlag.HydraBilling)) {
      throw redirect({ to: '/settings/billing/billing-history' });
    }
  },
  component: Journeys,
});
